import { HomeContent } from 'pages';

const Home = (props) => {
  return (
    <div id='home' className='w-full h-full px-10 pt-10 pb-20'>
      <HomeContent />
    </div>
  );
};

export default Home;
